import { fetches, generateFetchOpts, generateFetchOptsGetter } from 'api/client';
import { POST } from 'api/common';
import * as clientErrTypes from 'config/clientErrorTypes';

/**
 * 取得 MGM 關聯的模組編號資料 api https://app.clickup.com/t/866aq72wp
 * @param   {string} promoUUID promoUUID
 * @return  {promise}
 */
export const getMgmRelationByClientApi = promoUUID => {
    return fetches(`/promotions/${promoUUID}/mgm/relation`, generateFetchOpts(), {
        dataKeys: 'data'
    });
};

/**
 * @method createMgmEntryApi 建立 mgm 功能模組 entry
 * @description https://app.clickup.com/t/860rky8av
 * @param  {string} promoUuid 活動 Uuid
 * @param  {string} entryUuid Entry Uuid
 * @return  {promise}
 */
export function createMgmEntryApi({ promoUuid, entryUuid }) {
    return fetches(
        `/promotions/${promoUuid}/entries/${entryUuid}/mgm/referral/entry`,
        generateFetchOptsGetter({ method: POST }),
        {
            throwErrConfigs: {
                [clientErrTypes.MGM_CREATE_ENTRY_FAILED]: r => r.httpStatus !== 200
            }
        }
    );
}

/**
 * @method mgmLotteryValidationApi 檢查並觸發 mgm 功能模組配獎資格
 * @description https://app.clickup.com/t/866aqeruz
 * @param  {string} promoUuid 活動 Uuid
 * @param  {string} entryUuid Entry Uuid
 * @return  {promise}
 */
export function mgmLotteryValidationApi({ promoUuid, entryUuid }) {
    return fetches(
        `/promotions/${promoUuid}/entries/${entryUuid}/mgm/lottery/validation`,
        generateFetchOptsGetter({ method: POST }),
        {
            throwErrConfigs: {
                [clientErrTypes.MGM_LOTTERY_VALIDATION_FAILED.REFERRAL_ENTRY_NOT_FOUND]: r =>
                    r.httpStatus === 400 && r.payload.message === 'Mgm referral entry Not Found',
                [clientErrTypes.MGM_LOTTERY_VALIDATION_FAILED.EXCEPTION]: r => r.httpStatus !== 200
            }
        }
    );
}
